import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import { appConstant, apiUrl } from '@constants';
import { getAuthToken, handleErrorMessage, getKeyAndToken } from '@helpers';
import Actions from '../action';

export function* viewAffiliateWorker(action) {
	const { authKey } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_BY_ID}${action.id}&authKey=${authKey}`;
		const authToken = yield getAuthToken();
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getAffiliateByIDSuccess(res.data.messages));
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		// if (authKey) yield put(ActionsApp.creators.removeUser(authKey, action.history));
		yield put(Actions.creators.getAffiliateByIDFail());
	}
}
export function* viewAffiliateCommissionWorker(action) {
	try {
		const { authKey, authToken } = yield getKeyAndToken();
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_BY_ID_COMMISSION_PROFILE}${action.id}&authKey=${authKey}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getAffiliateByIDCommissionProfileSuccess(res.data.messages.message));
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		yield put(Actions.creators.getAffiliateByIDCommissionProfileFail());
	}
}
export function* deleteAffiliateCommissionWorker({ request, history }) {
	const { authKey, authToken } = yield getKeyAndToken();
	const hide = message.loading('Delete in progress..', 0);
	try {
		const uri = `${appConstant.domain + apiUrl.DELETE_CAMPAIGN}`;
		const res = yield call(Axios.delete, uri, { headers: { Authorization: authToken }, data: request });
		yield put(Actions.creators.deleteAffiliateByIDCommissionProfileSuccess());
		yield call(hide);
		yield put(Actions.creators.getAffiliateByIDCommissionProfile(request.sourceId, history));
	} catch (err) {
		console.log(err);
		yield call(hide);
		message.error(appConstant.somethingWentWrong);
	}
}

export default function* viewAffiliateWatcher() {
	yield takeEvery(Actions.types.GET_AFFILIATE_BY_ID_STARTED, viewAffiliateWorker);
	yield takeEvery(Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED, viewAffiliateCommissionWorker);
	yield takeEvery(Actions.types.DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED, deleteAffiliateCommissionWorker);
}
